import { getTechKeywordsForSlug } from './expertisesTechKeywords';

/** Dedicated solution landing pages (routes at site root). */
export const SOLUTION_PAGES = {
  'digital-twin': {
    icon: 'layers',
    image: 'images/digital-twin-page.jpg',
    titleKey: 'pages.solutions.digitalTwin.title',
    leadKey: 'pages.solutions.digitalTwin.lead',
    bodyKey: 'pages.solutions.digitalTwin.body',
    altKey: 'expertises.section.digitalTwin.alt',
    highlightsKeys: [
      'pages.solutions.digitalTwin.h1',
      'pages.solutions.digitalTwin.h2',
      'pages.solutions.digitalTwin.h3',
      'pages.solutions.digitalTwin.h4',
    ],
    techSlug: 'digital-twin',
    expertiseSlug: 'digital-twin',
    realisationId: 'medagricycle',
    externalUrl: null,
  },
  blockchain: {
    icon: 'link',
    image: 'images/blockchain2.jpg',
    titleKey: 'pages.solutions.blockchain.title',
    leadKey: 'pages.solutions.blockchain.lead',
    bodyKey: 'pages.solutions.blockchain.body',
    altKey: 'dataDriven.card.blockchain.alt',
    highlightsKeys: [
      'pages.solutions.blockchain.h1',
      'pages.solutions.blockchain.h2',
      'pages.solutions.blockchain.h3',
      'pages.solutions.blockchain.h4',
    ],
    techSlug: 'blockchain',
    expertiseSlug: 'blockchain',
    realisationId: 'techoney',
    externalUrl: null,
  },
  'e-living-lab': {
    icon: 'users',
    image: '/images/MedAgricycle.png',
    titleKey: 'pages.solutions.eLivingLab.title',
    leadKey: 'pages.solutions.eLivingLab.lead',
    bodyKey: 'pages.solutions.eLivingLab.body',
    altKey: 'pages.solutions.eLivingLab.alt',
    highlightsKeys: [
      'pages.solutions.eLivingLab.h1',
      'pages.solutions.eLivingLab.h2',
      'pages.solutions.eLivingLab.h3',
      'pages.solutions.eLivingLab.h4',
    ],
    techSlug: 'e-living-lab',
    expertiseSlug: null,
    realisationId: 'medagricycle',
    externalUrl: 'https://medagricycle.mmd-observatory.com',
  },
};

export function getSolutionPage(id) {
  const page = SOLUTION_PAGES[id];
  if (!page) return null;
  return {
    ...page,
    id,
    techKeywordsKeys: getTechKeywordsForSlug(page.techSlug),
  };
}

export const SOLUTION_PAGE_IDS = Object.keys(SOLUTION_PAGES);
